module.exports = __webpack_public_path__ + "img/epc-track-w.d54092c9.svg";